import type { SVGProps } from 'react';

const SvgPreBuiltTemplates = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="pre-built-templates">
      <path d="M31.29 9.38a2.76 2.76 0 0 0-2.75-2.75H28v1.5h.58a1.26 1.26 0 0 1 1.25 1.25v19.28a1.26 1.26 0 0 1-1.25 1.25H8.36a1.26 1.26 0 0 1-1.25-1.25v-1h-1.5v1a2.76 2.76 0 0 0 2.75 2.75h20.18a2.76 2.76 0 0 0 2.75-2.75Z" />
      <path d="M26.53 23.42V3.34A2.75 2.75 0 0 0 23.78.59H3.61A2.76 2.76 0 0 0 .86 3.34v20.08a2.75 2.75 0 0 0 2.75 2.75h20.17a2.75 2.75 0 0 0 2.75-2.75m-24.17 0V3.34a1.26 1.26 0 0 1 1.25-1.25h20.17A1.26 1.26 0 0 1 25 3.34v20.08a1.25 1.25 0 0 1-1.25 1.25H3.61a1.25 1.25 0 0 1-1.25-1.25" />
      <path d="M21.24 5.39H6.39a.76.76 0 0 0-.75.75v5.46a.76.76 0 0 0 .75.75h14.85a.76.76 0 0 0 .76-.75V6.14a.76.76 0 0 0-.76-.75m-.75 5.46H7.14v-4h13.35ZM6.27 15.17h15.09v1.5H6.27zM6.27 19.64h8.19v1.5H6.27z" />
    </g>
  </svg>
);

export default SvgPreBuiltTemplates;
